<template>
  <form class="authorization-form" ref="formContent" @submit.prevent="handleSubmit">
    <div class="document-header">
      <div class="left-container">
        <div class="logo-placeholder">
          <img src="/img/LOGOTIPOGOLDERGFUND.jpg" class="logo" alt="Company Logo" v-if="true">
          <div class="logo-text" v-else>LOGO</div>
        </div>
      </div>
      <div class="address-section">
        <p>Robert Schumann 4898</p>
        <p>Col. Lomas del seminario, CP.45038</p>
        <p>Zapopan, Jalisco.</p>
      </div>
    </div>

    <h2 class="section-title">Autorización consulta de buró</h2>

    <div class="form-section">

      <div class="form-row row-rigth">
        <label>Lugar:</label>
        <input type="text" v-model="formData.placeIssuance" placeholder="Lugar" class="underline-input">
        <label>Fecha:</label>
        <input type="date" v-model="formattedDateIssuance" class="underline-input" required>
      </div>

      <p class="authorization-text">
        Por este conducto autorizo expresamente a KVF GROUP SA DE CV para que lleve a cabo Investigaciones, sobre mi
        comportamiento crediticio o el de la Empresa que represento ante Trans Union de México, S. A. SIC y/o Dun &
        Bradstreet,
        S.A. SIC y/o cualquier otra sociedad autorizada para estos efectos.
      </p>

      <p class="authorization-text">
        Asimismo, declaro que conozco la naturaleza y alcance de las sociedades de información crediticia y de la
        información
        contenida en los reportes de crédito y reporte de crédito especial, declaro que conozco la naturaleza y alcance
        de la
        información que se solicitará, del uso que KVF GROUP SA DE CV, hará de tal información y de que ésta podrá
        realizar consultas
        periódicas sobre mi historial o el de la empresa que represento, consintiendo que esta autorización se encuentre
        vigente por
        un período de 3 años contados a partir de su expedición y en todo caso durante el tiempo que se mantenga la
        relación jurídica.
        En caso de que la solicitante sea una Persona Moral, declaro bajo protesta de decir verdad Ser Representante
        Legal de la
        empresa mencionada en esta autorización; manifestando que a la fecha de firma de la presente autorización los
        poderes no
        me han sido revocados, limitados, ni modificados en forma alguna.
      </p>

      <div class="authorization-type">
        <label class="mb-0">Autorización para:</label>
        <div class="checkboxes">
          <label class="checkbox-line">
            <input type="checkbox" v-model="formData.pf" class="hidden-checkbox" disabled>
            <span>Persona Física (PF)</span>
            <div class="line-checkbox">
              <span class="checkmark" :class="{ 'visible': formData.pf }">✓</span>
              <div class="line"></div>
            </div>
          </label>

          <label class="checkbox-line">
            <input type="checkbox" v-model="formData.pfae" class="hidden-checkbox" disabled>
            <span>Persona Física con Actividad Empresarial (PFAE)</span>
            <div class="line-checkbox">
              <span class="checkmark" :class="{ 'visible': formData.pfae }">✓</span>
              <div class="line"></div>
            </div>
          </label>

          <label class="checkbox-line">
            <input type="checkbox" v-model="formData.pm" class="hidden-checkbox" disabled>
            <span>Persona Moral (PM)</span>
            <div class="line-checkbox">
              <span class="checkmark" :class="{ 'visible': formData.pm }">✓</span>
              <div class="line"></div>
            </div>
          </label>
        </div>
      </div>

      <div class="form-fields">
        <div class="form-row">
          <label>Nombre del solicitante (Persona Física o Razón Social de la Persona Moral):</label>
          <input type="text" v-model="formData.nombreSolicitante" class="underline-input-lg" disabled>
        </div>

        <div class="form-row">
          <label>Para el caso de Persona Moral, nombre del Representante Legal:</label>
          <input type="text" v-model="formData.representanteLegal" class="underline-input-lg" disabled>
        </div>

        <div class="form-row">
          <label>RFC o CURP:</label>
          <input type="text" v-model="formData.rfcCurp" class="underline-input" disabled>
        </div>

        <div class="form-row">
          <label>Domicilio:</label>
          <input type="text" v-model="formData.domicilio" class="underline-input" disabled style="min-width: 56%;">
        </div>

        <div class="form-row">
          <label>Colonia:</label>
          <input type="text" v-model="formData.colonia" class="underline-input" disabled>
        </div>

        <div class="form-row">
          <label>Municipio:</label>
          <input type="text" v-model="formData.municipio" class="underline-input" disabled>
          <label>Estado:</label>
          <input type="text" v-model="formData.estado" class="underline-input" disabled>
        </div>

        <div class="form-row">
          <label>Teléfono(s):</label>
          <input type="text" v-model="formData.telefonos" class="underline-input" disabled style="min-width:35%;">
        </div>

        <div class="form-row">
          <label>Lugar y Fecha en que se firma la autorización:</label>
          <input type="text" v-model="formData.signedAddress" class="underline-input">
          <input type="date" v-model="formattedDateSigned" class="underline-input" required>
        </div>

        <div class="form-row">
          <label>Nombre del funcionario que recaba la autorización:</label>
          <input type="text" v-model="formData.officerFullName" class="underline-input-lg">
        </div>
      </div>

      <p class="disclaimer">
        <strong>Estoy consciente y acepto que este documento quede bajo custodia de KVF GROUP SA DE CV y/o Sociedad de
          Información Crediticia consultada para efectos de control y cumplimiento del artículo 28 de la Ley para
          Regular las
          Sociedades de Información Crediticia; mismo que señala que las Sociedades sólo podrán proporcionar información
          a un
          Usuario, cuando éste cuente con la autorización expresa del Cliente mediante su firma autógrafa.</strong>
      </p>

      <div class="signature-section">
        <div class="signature-line"></div>
        <p>Nombre de la persona</p>
      </div>

      <div class="company-use">
        <div class="form-row">
          <label>Para uso exclusivo de la Empresa que efectúa la consulta</label>
          <input type="text" class="underline-input" v-model="formData.companyName">
        </div>
        <div class="form-row">
          <label>Fecha de Consulta BC:</label>
          <input type="date" v-model="formattedDateInquiry" class="underline-input" required>
        </div>
        <div class="form-row">
          <label>Folio de Consulta BC:</label>
          <input type="text" v-model="formData.referenceNumber" class="underline-input" disabled>
        </div>
      </div>
      <p>
        IMPORTANTE: Este formato debe ser llenado individualmente, para una sola persona física ó para una sola empresa.
        En caso
        de requerir el Historial crediticio del representante legal, favor de llenar un formato adicional.
      </p>
    </div>

    <div class="form-actions">
      <button type="submit" class="download-btn">Descargar PDF</button>
      <div v-if="validationErrors.length" class="validation-errors">
        <p v-for="(error, index) in validationErrors" :key="index" class="error-message">{{ error }}</p>
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions } from 'pinia';
import html2pdf from 'html2pdf.js';
import { useAuthorizationBureauConsultationStore } from '@/pinia/LoanApplications/Legal/authotizationBureauConsultation.module';

export default {
  props: {
    formData: {
      type: Object,
      required: true,
      default: () => ({
        placeIssuance: '',
        dateIssuance: '',
        pf: false,
        pfae: false,
        pm: false,
        nombreSolicitante: '',
        representanteLegal: '',
        rfcCurp: '',
        domicilio: '',
        colonia: '',
        municipio: '',
        estado: '',
        telefonos: '',
        signedAddress: '',
        signedDate: '',
        officerFullName: '',
        inquiryDate: '',
        referenceNumber: '',
        companyName: '',
        loanApplicationId: null,
        statusId: null
      }) // Opcional: valor por defecto
    },
    editAction: {
      type: Boolean,
      required: true,
      default: () => (false)
    },
    editId: {
      type: Number,
      required: false,
      default: () => (null)
    }
  },
  data() {
    return {
      validationErrors: []
    }
  },
  methods: {
    ...mapActions(useAuthorizationBureauConsultationStore, ['createBureauConsultation', 'updateBureauConsultation']),
    validateForm() {
      this.validationErrors = [];
      let isValid = true;

      // Validación de campos requeridos
      const requiredFields = [
        { field: 'dateIssuance', message: 'La fecha de emisión es requerida' },
        { field: 'signedDate', message: 'La fecha de firma es requerida' },
        { field: 'inquiryDate', message: 'La fecha de consulta BC es requerida' }
      ];

      requiredFields.forEach(({ field, message }) => {
        if (!this.formData[field]?.toString().trim()) {
          this.validationErrors.push(message);
          isValid = false;
        }
      });

      // Validación de al menos un tipo de autorización
      if (!this.formData.pf && !this.formData.pfae && !this.formData.pm) {
        this.validationErrors.push('Debe seleccionar al menos un tipo de autorización');
        isValid = false;
      }

      return isValid;
    },
    async handleSubmit() {
      if (this.validateForm()) {
        try {
          /**Configuración para Guardar los datos de Autorización de consulta de buro en BD */
          let payloadBureau = {
            loanApplicationId: this.formData.loanApplicationId,
            statusId: this.formData.statusId,
            placeIssuance: this.formData.placeIssuance,
            dateIssuance: this.formData.dateIssuance,
            signedAddress: this.formData.signedAddress,
            signedDate: this.formData.signedDate,
            officerFullName: this.formData.officerFullName,
            personAuthorizingFullName: "",
            companyName: this.formData.companyName,
            inquiryDate: this.formData.inquiryDate
          };

          /**Diferenciar que tipo de formulario es si es una edición o una creación para determinar la ruta de guardado */
          if (this.editAction) {
            payloadBureau.id = this.editId;
            /**Actualizar registro */
            const response = await this.updateBureauConsultation(payloadBureau);
            if (response && response.status) {
              await this.downloadPDF();
            }
          } else {
            /**Crear nuevo registro */
            const response = await this.createBureauConsultation(payloadBureau);
            if (response && response.status) {
              this.formData.referenceNumber = response.data.referenceNumber;
              await this.downloadPDF();
            }
          }
        } catch (error) {
          console.error('Error save data of PDF:', error);
        } finally {
          console.info("Save data PDF succes");
        }
      } else {
        this.$nextTick(() => {
          const errorElement = document.querySelector('.validation-errors');
          if (errorElement) {
            errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
      }
    },
    async downloadPDF() {
      /**Configuración de la acción de descarga de PDF */
      const formActions = document.querySelector('.form-actions');

      // Ocultando boton de descarga PDF
      if (formActions) formActions.style.display = 'none';

      /** Configuración del contenido del PDF para la descarga*/
      // Guardar estilos originales
      const originalStyles = {
        formSection: Array.from(document.querySelectorAll('.form-section, .form-section *')).map(el => ({
          fontSize: el.style.fontSize,
          //lineHeight: el.style.lineHeight
        }))
      };

      // Aplicar estilos reducidos solo a .form-section y sus hijos
      document.querySelectorAll('.form-section, .form-section *').forEach(el => {
        el.style.fontSize = '11.6px';
        //el.style.lineHeight = '1.3';
      });

      // Parametros de configuración para el archivo de descarga PDF
      const opt = {
        margin: 0,
        filename: 'Autorizacion_Consulta_Buro.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: {
          scale: 2,
          logging: true,
          useCORS: true
        },
        jsPDF: {
          unit: 'mm',
          format: 'a4',
          orientation: 'portrait'
        }
      };

      /** Configuración para proceder a la descarga del pdf al equipo local */
      try {
        await html2pdf().set(opt).from(this.$refs.formContent).save();
      } catch (error) {
        console.error('Error generating PDF:', error);
      } finally {
        // Restaurar estilos originales
        document.querySelectorAll('.form-section, .form-section *').forEach((el, i) => {
          if (originalStyles.formSection[i]) {
            el.style.fontSize = originalStyles.formSection[i].fontSize;
            //el.style.lineHeight = originalStyles.formSection[i].lineHeight;
          }
        });

        if (formActions) formActions.style.display = 'block';
      }
    }
  },
  computed: {
    formattedDateIssuance: {
      get() {
        return this.$filters.formatDateForInput(this.formData.dateIssuance);
      },
      set(value) {
        this.formData.dateIssuance = value;
      }
    },
    formattedDateSigned: {
      get() {
        return this.$filters.formatDateForInput(this.formData.signedDate);
      },
      set(value) {
        this.formData.signedDate = value;
      }
    },
    formattedDateInquiry: {
      get() {
        return this.$filters.formatDateForInput(this.formData.inquiryDate);
      },
      set(value) {
        this.formData.inquiryDate = value;
      }
    }
  }
};
</script>
<style scoped>
.authorization-form {
  font-family: Arial, sans-serif;
  margin: 0 auto;
  position: relative;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-left: 80px solid #f8a845;
  padding-left: 20px;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-right: 59px;
}

.document-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.left-container {
  display: flex;
  align-items: flex-start;
}

.left-container {
  width: 120px;
  display: flex;
  align-items: center;
}

.logo {
  max-width: 200%;
  max-height: 200%;
}

.logo-placeholder {
  width: 200%;
  display: flex;
  align-items: center;
  color: #999;
}

.logo-text {
  display: inline-block;
  border: 1px dashed #999;
  padding: 10px 20px;
  color: #666;
  font-weight: bold;
}

.address-section {
  text-align: right;
  line-height: 1;
  margin-top: 10px;
}

.section-title {
  text-align: center;
  margin-bottom: 20px;
  font-size: 1.2em;
  font-weight: bold;
}

.form-section {
  margin-bottom: 20px;
  margin-left: 35px;
}

.form-row.row-rigth {
  display: inherit;
  text-align: right;
}

.form-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  flex-wrap: wrap;
  margin-right: 0px;
  margin-left: 0px;
}

label {
  font-weight: normal !important;
  margin-bottom: 0px !important;
}

.form-row label {
  margin-right: 10px;
  font-weight: normal;
}

.underline-input {
  /*padding: 5px 0;*/
  border: none;
  border-bottom: 1px solid #000;
  background: transparent;
  margin-right: 20px;
  /*min-width: 300px;*/
  /*min-width: 35%;*/
}

.underline-input-lg {
  border: none;
  border-bottom: 1px solid #000;
  background: transparent;
  min-width: 100%;
}

.underline-input:focus,
.underline-input-lg:focus {
  outline: none;
  border-bottom: 2px solid #f8a845;
}

.underline-input-check {
  padding: 5px 0;
  border: none;
  border-bottom: 1px solid #000;
  background: transparent;
  margin-right: 20px;
}

.underline-input-check:focus {
  outline: none;
  border-bottom: 2px solid #f8a845;
}

.authorization-text {
  text-align: justify;
  margin-bottom: 15px;
  /*line-height: 1.5;*/
  line-height: 1.1;
}

.authorization-type {
  margin-bottom: 10px;
}

.checkboxes div {
  display: flex;
  align-items: center;
}

.checkboxes input {
  margin-right: 8px;
}

.checkboxes {
  display: flex;
  flex-direction: row;
  gap: 15px;
}

.checkbox-line {
  display: flex;
  align-items: flex-end;
  cursor: pointer;
  /*gap: 10px;*/
  position: relative;
}

.label-text {
  white-space: nowrap;
}

.line-checkbox {
  position: relative;
  min-width: 40px;
}

.line {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border-bottom: 1px solid #000;
  width: 100%;
}

.hidden-checkbox {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.checkmark {
  position: absolute;
  left: 50%;
  bottom: 100%;
  transform: translateX(-50%);
  font-size: 16px;
  color: #000;
  opacity: 0;
  transition: opacity 0.2s;
  margin-bottom: 2px;
}

.checkmark.visible {
  opacity: 1;
}

.disclaimer {
  font-weight: bold;
  text-align: justify;
  margin: 10px 0;
  /*line-height: 1.5;*/
  line-height: 1.1;
}

.signature-section {
  text-align: center;
  /*margin-top: 30px;*/
  margin-top: 35px;
}

.signature-line {
  border-top: 1px solid #000;
  width: 50%;
  /*margin: 0 auto 5px;*/
  margin: 0 auto 0px;
}

.company-use p {
  font-weight: bold;
}

.important-note {
  font-size: 0.9em;
  margin-top: 20px;
  color: #666;
}

.form-actions {
  text-align: center;
  margin-top: 30px;
}

.download-btn {
  background-color: #f8a845;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
}

.download-btn:hover {
  background-color: #E05D00;
}

.print-btn {
  background-color: #4a6da7;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  margin-left: 10px;
}

.print-btn:hover {
  background-color: #3a5a8f;
}

@media print {

  .authorization-form {
    box-shadow: none;
  }

  .form-section {
    margin-bottom: 10px;
  }

  .form-actions {
    display: none;
  }

  .underline-input {
    border-bottom: 1px solid #000 !important;
  }
}

/* Agrega estos estilos Validaciones */
.validation-errors {
  margin-top: 15px;
  padding: 10px;
  background-color: #ffeeee;
  border: 1px solid #ffcccc;
  border-radius: 4px;
}

.error-message {
  color: #d32f2f;
  margin: 5px 0;
  font-size: 0.9em;
}

/* Estilo para campos inválidos */
input:invalid {
  border-color: #d32f2f;
}
</style>